import React, { useMemo, useState } from 'react';

import { TaskListSearchContext } from './context';

export type TaskListSearchProviderProps = {
  children: React.ReactNode;
};

export const TaskListSearchProvider: React.FC<TaskListSearchProviderProps> = ({
  children,
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const value = useMemo(() => ({ searchQuery, setSearchQuery }), [searchQuery]);

  return (
    <TaskListSearchContext.Provider value={value}>
      {children}
    </TaskListSearchContext.Provider>
  );
};
